import styled from 'styled-components';
import { Box } from '@material-ui/core';

import theme from '../../styles/defaultTheme';

export const TextHome = styled.div`
  font-size: ${theme.font.size16};
  color: ${(props) => props.theme.black};
`;

export const BannerContainer = styled.div`
  max-width: 100%;
  margin-bottom: 24px;
`;

export const HomeContainer = styled(Box)`
  @media screen and (max-width: 1200px) {
    flex-direction: column;
  }
`;

export const Card = styled.div`
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0px 6px 8px #6565651A;
  background-color: ${(props) => props.theme.white};
  border: 1px solid ${(props) => props.theme.borderWhite};
  
  & + & {
    margin-top: 24px;
  }
`;

export const TitleCard = styled.div`
  font-size: ${theme.font.size24};
  color: ${(props) => props.theme.black};
  font-weight: bold;
`;

export const QuickLinks = styled.div`
`;

export const VerticalLine = styled.div`
  height: 72px;
  width: 1px;
  background-color: ${(props) => props.theme.grey20};
`;

export const TextContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const TextDates = styled.div`
  font-size: ${theme.font.size24};
  color: ${(props) => props.theme.black};
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TitleCards = styled.div`
  font-size: ${theme.font.size12};
  font-weight: normal;
  width: 104px;
  text-align: center;
`;